import { z } from 'zod';

export const AmazonRegions = {
  north_america: 'north_america',
  europe: 'europe',
  far_east: 'far_east',
} as const;

export const OmniAuthAuthorizeRequestSchema = z.object({
  integrationName: z.string().nullable().optional(),
  platform: z.string().nullable().optional(),
  integrationId: z.string().nullable().optional(),
  connectionName: z.string().optional(),
  connectionId: z.string().optional(),
  region: z.enum(AmazonRegions).nullable().optional(),
});

export const OmniAuthAuthorizeResponseSchema = z.object({
  data: z.object({
    items: z.array(z.object({ redirectUrl: z.string() })),
  }),
});
